import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Horse_show_entry_with_type } from '../../models/horse_show_entry_with_type';
import { Entry_type } from '../../models/entry_type';
import { Additional_field, Additional_field_response } from '../../models/additional_field';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';

import { faCalendar, faSave }  from '@fortawesome/fontawesome-pro-regular';

import dayjs from 'dayjs';
import {AccountEntryView} from '../../models/account_entry_view';
import {Horse_show_entry} from '../../models/horse_show_entry';
import {PendingHorseShowEntryService} from '../../providers/pending-horse-show-entry.service';
import {EntryTypeService} from '../../providers/entry-type.service';


@Component({
  standalone: false,
  selector: 'app-modal-edit-misc-on-entry',
  templateUrl: './modal-edit-misc-on-entry.component.html',
styleUrls:  ['./modal-edit-misc-on-entry.component.css']
})
export class ModalEditMiscOnEntryComponent extends SmsAbstractAppPage implements OnInit {

	faCalendar = faCalendar;
	faSave = faSave;

	entry_arrival_date: NgbDateStruct;

	horse_show_name: string = '';
	horse_show_entry: Horse_show_entry = null;

  accountEntryView: AccountEntryView = null;
	saved$: EventEmitter<AccountEntryView> = new EventEmitter<AccountEntryView>();

  entry_type: Entry_type = new Entry_type({});

  left_additional_fields: Additional_field[] = [];
  right_additional_fields: Additional_field[] = [];
  additional_field_response_map: Map<string, Additional_field_response> = new Map<string, Additional_field_response>();

  constructor(public activeModal: NgbActiveModal,
              private pendingHorseShowEntryService: PendingHorseShowEntryService,
              private entryTypeService: EntryTypeService) {
    super();
  }

  ngOnInit() {
  }

  handleSave() {

    //Handle Additional fields
      let field_responses: Additional_field_response[] = [];
      this.additional_field_response_map.forEach((field, key) => {
        if(field.value != ''){
          field_responses.push(field);
        }
      });

    this.horse_show_entry.additional_fields = field_responses;

    this.pendingHorseShowEntryService.updateAdditionalInformation(this.horse_show_entry).then(response => {

      this.saved$.emit(this.accountEntryView);

    }).catch(error => {this.handleError(error)});



  }

  private loadArrivalDate(horse_show_entry: Horse_show_entry){
    let hse_arrival_date:Date  = dayjs(horse_show_entry.arrival_date, 'YYYY-MM-DD').toDate();
    this.entry_arrival_date = {year: hse_arrival_date.getFullYear(), month: hse_arrival_date.getMonth() + 1, day: hse_arrival_date.getDate()};
  }


  setHorse_show_entry(entryView: AccountEntryView){

    this.accountEntryView = entryView;

    this.pendingHorseShowEntryService.get(entryView.entryId).then(horseShowEntry => {
      this.horse_show_entry = horseShowEntry;
      if(horseShowEntry.arrival_date != undefined){
        this.loadArrivalDate(horseShowEntry);
      }
      this.entryTypeService.get(entryView.horseShowId, horseShowEntry.entry_type).then(entryType => {
        this.entry_type = entryType;

        //Populate additional fields
        this.entry_type.additional_fields.forEach((field, i) => {
          this.additional_field_response_map.set(field.name, new Additional_field_response({name: field.name, value: ''}));

          if(i % 2 == 0){
            this.left_additional_fields.push(field);
          } else {
            this.right_additional_fields.push(field);
          }

        });



        if(this.horse_show_entry.additional_fields != undefined && this.horse_show_entry.additional_fields.length > 0){
          try {

            this.horse_show_entry.additional_fields.forEach((field, i) => {

              this.additional_field_response_map.set(field.name, field);
            });

          } catch (error){
            this.handleError(error);
          }
        }

      }).catch(error => {
        this.handleError(error);
      });
    }).catch(error => {
      this.handleError(error);
    });

  }

}
